import m from '@bitstillery/mithril'
import {MithrilComponent} from '@bitstillery/mithril'
import {Button} from '@bitstillery/common/components/portal'
import {$t} from '@bitstillery/common/app'

export interface FooterFunFactModalAttrs {
    id: string
    image_src: string
    onclick: () => void
}

export class FooterFunFactModal extends MithrilComponent<FooterFunFactModalAttrs> {
    view(vnode: m.Vnode<FooterFunFactModalAttrs>) {
        // @i18n ignore: landing.footer_fun_facts.**.{body,title}`
        const key = (suffix: string) => `landing.footer_fun_facts.${vnode.attrs.id}.${suffix}` as const
        const title_id = `footer-fun-fact-modal-title-${vnode.attrs.id}`

        return (
            <div className='footer-fun-fact-modal-backdrop' role='presentation'>
                <div className='footer-fun-fact-modal' role='dialog'>
                    <Button
                        className='footer-fun-fact-modal-close'
                        icon='close'
                        link='/our-team'
                        onclick={vnode.attrs.onclick}
                        size='l'
                        variant='icon'
                    />
                    <div className='footer-fun-fact-modal-text'>
                        <h2 id={title_id} className='footer-fun-fact-modal-title'>
                            {$t(key('title'))}
                        </h2>
                        <p className='footer-fun-fact-modal-body'>{$t(key('body'))}</p>
                        <Button
                            onclick={() => {
                                void m.route.set('/our-team')
                                vnode.attrs.onclick()
                            }}
                            variant='link'
                            text={$t('landing.footer_fun_fact_team_cta')}
                            type='info'
                        />
                    </div>
                    <div className='footer-fun-fact-modal-image-wrap'>
                        <img
                            alt={$t(key('image_alt'))}
                            className='footer-fun-fact-modal-image'
                            decoding='async'
                            loading='lazy'
                            src={vnode.attrs.image_src}
                        />
                    </div>
                </div>
            </div>
        )
    }
}
